import http from './http'

export async function getPermission() {
  const res = await http.get('/permission/current')
  return res.data
}

export async function savePermission(payload) {
  const res = await http.post('/permission/update', payload)
  return res.data
}

export async function getReportPeriodsAll() {
  const res = await http.get('/report-periods-time/all')
  return res.data
}

export async function getReportPeriodsEnabled() {
  const res = await http.get('/report-periods-time/enabled')
  return res.data
}

export async function insertReportPeriod(payload) {
  const res = await http.post('/report-periods-time/insert', payload)
  return res.data
}

export async function updateReportPeriod(payload) {
  const res = await http.put('/report-periods-time/update', payload)
  return res.data
}

export async function deleteReportPeriod(id) {
  const res = await http.delete(`/report-periods-time/delete/${id}`)
  return res.data
}

export async function getRoles() {
  const res = await http.get('/api/permission/roles')
  return res.data
}

export async function getModules() {
  const res = await http.get('/api/permission/modules')
  return res.data
}

export async function getRoleModulePermissions(roleId) {
  const res = await http.get(`/api/permission/role/${roleId}`)
  return res.data
}

export async function saveRoleModulePermissions(roleId, payload) {
  const res = await http.post(`/api/permission/role/${roleId}`, payload)
  return res.data
}